import { CmsOrderConfirmationPage } from '../../models/cms/cms-order-confirmation-page.interface';

export const mockCmsOrderConfirmationPage: CmsOrderConfirmationPage = {
  pageTitle: 'pageTitle',
  pageSubtitle: 'pageSubtitle',
  protectionCardBannerPlanHeader: 'protectionCardBannerPlanHeader',
};
